import { render, staticRenderFns } from "./meals-table.vue?vue&type=template&id=23dc56d2&"
import script from "./meals-table.vue?vue&type=script&lang=js&"
export * from "./meals-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports